import { Flex, Typography } from "antd";
import { FC } from "react";

import { getColorsSectionGroupButton, getSectionGroupIcon, SectionGroupButtonColor } from "../../../../shared/components/SectionGroupButtons/utils";

import { AppstoreOutlined, CarOutlined, HeartOutlined, HomeOutlined } from "@ant-design/icons";
import { BranchGroup } from "../../../../shared/interfaces/services/get-home-services";

import './index.css';
import { formattedPercentage } from "../../../../shared/utils";

interface homeIconsRenderProps {
    values: BranchGroup[];
    color: SectionGroupButtonColor;
}

export const HomeIconsRender: FC<homeIconsRenderProps> = ({color, values}) => {

    const { iconColor } = getColorsSectionGroupButton(color);
    

    const items = [
        {
            iconName: <CarOutlined/>,
            title: 'Autos',
            value: values[0]
        },
        {
            iconName: <HomeOutlined/>,
            title: 'Hogar',
            value: values[1]
        },
        {
            iconName: <HeartOutlined/>,
            title: 'Vida',
            value: values[2]
        },
        {
            iconName: <AppstoreOutlined/>,
            title: 'Resto',
            value: values[3]
        }
    ];

    return (
        <Flex  
            justify={"space-evenly"} 
            className="w-100" 
            wrap="wrap"
            gap="large"
        >
            {
                items.map((item, index) => (
                    <Flex justify='center' gap='small' className='home-icons-render__icon-card' key={index}>
                        { getSectionGroupIcon(item.iconName, iconColor)}
            
                        <Flex 
                            vertical 
                            className='home-icons-render__container-title-section-group-button'
                         > 
                            {
                                item.value?.porcentaje ? (
                                    <Typography.Title className="title" level={4}>
                                        { formattedPercentage(item.value.porcentaje || '0') }
                                    </Typography.Title>
                                ) : 
                                (
                                    <Typography.Title className="title" level={4}>
                                        { item.value?.cantidad || '0' }
                                    </Typography.Title>
                                )
                            }
                            <Typography.Text>
                                { item.title }
                            </Typography.Text>
                        </Flex>
                    </Flex>
                ))
            }
        </Flex>
    );
}
